module.exports = __webpack_public_path__ + "img/default_product_image.285c03a0.svg";